<!--
* @Name：芯片不良品处理明细信息
* @Author: LYS
* @Date: 2024-07-05 11:42:31
-->
<template>
  <div>
    <hi-card v-for="(item, index) in chipInfo" :key="item.id" :row-index="index + 1">
      <van-row>
        <span>物料编码：</span>
        <span>{{ item.matnr }}</span>
      </van-row>
      <van-row>
        <span>物料描述：</span>
        <span>{{ item.maktx }}</span>
      </van-row>
      <van-row>
        <span>数量：</span>
        <span>{{ item.stockInQty }}</span>
      </van-row>
      <van-row>
        <span>原含税单价：</span>
        <span>{{ item.taxPrice }}</span>
      </van-row>
      <van-row>
        <span>含税单价：</span>
        <span>{{ item.adjustedTaxPrice }}</span>
      </van-row>
      <van-row>
        <span>调价原因：</span>
        <span>{{ item.adjustedReason }}</span>
      </van-row>
      <van-row>
        <span>未税金额：</span>
        <span>{{ item.adjustedUntaxedAmount }}</span>
      </van-row>
      <van-row>
        <span>税额：</span>
        <span>{{ item.adjustedTaxAmount }}</span>
      </van-row>
      <van-row>
        <span>价税合计：</span>
        <span>{{ item.adjustedSumAmount }}</span>
      </van-row>
    </hi-card>
  </div>
</template>
<script>
export default {
  name: 'DefectiveChipInfo',
  mixins: [],
  components: {},
  data() {
    return {}
  },
  props: {
    chipInfo: {
      type: Array,
      default: () => []
    }
  },
  computed: {},
  watch: {},
  methods: {},
  filters: {},
  directives: {}
}
</script>

<style scoped></style>
